var _text, _text2, _text3, _text4, _text5, _text6, _line, _line2, _line3, _line4, _line5, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _path4, _path5, _path6, _path7, _path8, _path9, _g7, _g8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 350,
    viewBox: "0 0 227 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 30,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Networth"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 90,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Goals & Expenses"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 150,
    fill: "#0B2653",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", null, "Post Retirement Income"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 205,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Risk Assesment"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 260,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Asset Allocation"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 315,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Portfolio Construction"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 46,
    x2: 33,
    y2: 68,
    stroke: "#27AE60",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 106,
    x2: 33,
    y2: 128,
    stroke: "#27AE60",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 162,
    x2: 33,
    y2: 186,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 218,
    x2: 33,
    y2: 242,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 274,
    x2: 33,
    y2: 298,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 125C34.7578 125 37.4885 125.543 40.0364 126.599C42.5842 127.654 44.8992 129.201 46.8492 131.151C48.7993 133.101 50.3461 135.416 51.4015 137.964C52.4568 140.511 53 143.242 53 146H50.0802C50.0802 143.626 49.6126 141.275 48.704 139.081C47.7953 136.887 46.4636 134.894 44.7847 133.215C43.1058 131.536 41.1126 130.205 38.919 129.296C36.7254 128.387 34.3743 127.92 32 127.92L32 125Z",
    fill: "#D17837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 7C43.598 7 53 16.402 53 28C53 39.598 43.598 49 32 49C20.402 49 11 39.598 11 28C11 16.402 20.402 7 32 7ZM32 46.0802C41.9854 46.0802 50.0802 37.9854 50.0802 28C50.0802 18.0146 41.9854 9.91976 32 9.91976C22.0146 9.91976 13.9198 18.0146 13.9198 28C13.9198 37.9854 22.0146 46.0802 32 46.0802Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66C43.598 66 53 75.402 53 87C53 98.598 43.598 108 32 108C20.402 108 11 98.598 11 87C11 75.402 20.402 66 32 66ZM32 105.08C41.9854 105.08 50.0802 96.9854 50.0802 87C50.0802 77.0146 41.9854 68.9198 32 68.9198C22.0146 68.9198 13.9198 77.0146 13.9198 87C13.9198 96.9854 22.0146 105.08 32 105.08Z",
    fill: "#27AE60"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_210_182)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 16,
    fill: "#27AE60"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 31.6978L25.6258 28.3865C25.2534 28.0143 24.6517 28.0143 24.2793 28.3865C23.9069 28.7586 23.9069 29.3598 24.2793 29.732L28.271 33.7209C28.6434 34.093 29.245 34.093 29.6174 33.7209L39.7207 23.6247C40.0931 23.2525 40.0931 22.6513 39.7207 22.2791C39.3483 21.907 38.7466 21.907 38.3742 22.2791L28.9394 31.6978Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_210_182)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 87,
    r: 16,
    fill: "#27AE60"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_210_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 90.6978L25.6258 87.3865C25.2534 87.0143 24.6517 87.0143 24.2793 87.3865C23.9069 87.7586 23.9069 88.3598 24.2793 88.732L28.271 92.7209C28.6434 93.093 29.245 93.093 29.6174 92.7209L39.7207 82.6247C40.0931 82.2525 40.0931 81.6513 39.7207 81.2791C39.3483 80.907 38.7466 80.907 38.3742 81.2791L28.9394 90.6978Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_210_182)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 202,
    r: 16,
    fill: "#0B2653"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.2926 196.844C36.2821 196.705 34.3459 195.873 32.9309 194.555L32.5584 194.208C32.4096 194.069 32.2234 194 32 194C31.7767 194 31.5904 194.069 31.4416 194.208L31.0692 194.555C29.6171 195.907 27.7183 196.705 25.7075 196.844C25.2979 196.878 25 197.191 25 197.572V199.653C25 204.022 27.5317 208.079 31.6276 210.229C31.7392 210.299 31.8883 210.333 32 210.333C32.1488 210.333 32.2608 210.299 32.3724 210.229C36.4683 208.079 39 204.022 39 199.653V197.572C39 197.191 38.7021 196.879 38.2925 196.844H38.2926ZM31.9629 197.711C32.5959 197.711 33.1171 198.196 33.08 198.82L32.8566 202.878C32.8195 203.329 32.4471 203.675 31.963 203.675C31.4789 203.675 31.1067 203.328 31.0693 202.878L30.8459 198.82C30.8459 198.196 31.33 197.711 31.963 197.711H31.9629ZM31.9629 206.657C31.2929 206.657 30.7713 206.172 30.7713 205.548C30.7713 204.923 31.2926 204.438 31.9629 204.438C32.633 204.438 33.1545 204.923 33.1545 205.548C33.1543 206.172 32.633 206.657 31.9629 206.657Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_210_182)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 146,
    r: 16,
    fill: "#D17837"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9672 144.064H23.9777C23.6912 144.064 23.457 144.299 23.457 144.585V150.539C23.457 150.826 23.6912 151.06 23.9777 151.06H26.9672C27.2538 151.06 27.4879 150.826 27.4879 150.539V144.588C27.4879 144.299 27.2566 144.065 26.9672 144.065V144.064ZM26.0442 150.327C25.7301 150.327 25.4739 150.071 25.4739 149.757C25.4739 149.443 25.7301 149.187 26.0442 149.187C26.3582 149.187 26.6144 149.443 26.6144 149.757C26.6146 150.071 26.3583 150.327 26.0442 150.327Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5286 146.914C40.3494 146.801 40.1263 146.787 39.9362 146.881L36.5886 148.426C36.3737 148.71 36.0348 148.892 35.6518 148.892H32.7478C32.5962 148.892 32.4723 148.768 32.4723 148.616C32.4723 148.465 32.5962 148.341 32.7478 148.341H35.6518C35.8749 148.341 36.0733 148.222 36.1835 148.046C36.2111 148.005 36.2303 147.958 36.247 147.911C36.2524 147.897 36.2552 147.886 36.258 147.873C36.2718 147.82 36.2801 147.768 36.2801 147.713C36.2801 147.366 35.9963 147.082 35.6491 147.082H33.5744C33.5055 147.082 33.4394 147.057 33.3899 147.01C32.4778 146.186 31.3316 145.679 30.3288 145.655C29.403 145.633 28.5599 145.638 28.0392 145.644L28.0391 149.749C29.3754 150.518 32.004 151.895 33.0538 151.832C35.2773 151.705 40.4242 148.016 40.4738 147.978C40.4821 147.972 40.4903 147.967 40.4986 147.961C40.6914 147.854 40.8099 147.65 40.8099 147.429C40.8154 147.22 40.7107 147.03 40.5289 146.914L40.5286 146.914Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6 139.568C37.6 140.158 36.3465 140.636 34.8 140.636C33.2536 140.636 32 140.158 32 139.568C32 138.978 33.2536 138.5 34.8 138.5C36.3464 138.5 37.6 138.978 37.6 139.568Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8001 145.46C36.4027 145.46 37.6001 144.896 37.6001 144.392L37.6 143.671C37.0163 144.102 36.0019 144.376 34.8 144.376C33.5981 144.376 32.5837 144.102 32 143.671V144.392C32.0001 144.896 33.1975 145.46 34.8002 145.46H34.8001Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8001 143.852C36.4027 143.852 37.6001 143.288 37.6001 142.783L37.6 142.062C37.0163 142.493 36.0019 142.767 34.8 142.767C33.5981 142.767 32.5837 142.493 32 142.062V142.783C32.0001 143.288 33.1975 143.852 34.8002 143.852H34.8001Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8001 142.244C36.4027 142.244 37.6001 141.68 37.6001 141.176L37.6 140.455C37.0163 140.886 36.0019 141.16 34.8 141.16C33.5981 141.16 32.5837 140.886 32 140.455V141.176C32.0001 141.68 33.1975 142.244 34.8002 142.244H34.8001Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_210_182)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 258,
    r: 16,
    fill: "#4081BD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.5559 255.937C38.1502 254.606 37.3455 253.466 36.2268 252.633L32.5996 257.755L38.4679 259.98C38.9316 258.664 38.9621 257.268 38.556 255.937L38.5559 255.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4826 258.112L31.4653 258.097C31.4486 258.078 31.4366 258.057 31.4295 258.034C31.4146 257.986 31.4232 257.932 31.4531 257.889L35.2042 252.592C35.0212 252.47 34.8306 252.355 34.6354 252.251C33.6929 251.75 32.6391 251.484 31.5877 251.484C30.9487 251.484 30.3109 251.58 29.6921 251.769C28.0314 252.276 26.6676 253.399 25.8516 254.931C25.0357 256.464 24.8654 258.222 25.3719 259.883C25.8786 261.544 27.0017 262.907 28.5342 263.724C29.475 264.225 30.5281 264.489 31.5804 264.489C32.2224 264.489 32.8638 264.393 33.4861 264.203C35.3611 263.631 36.8561 262.264 37.5998 260.444L31.511 258.133C31.4973 258.126 31.488 258.118 31.4824 258.113L31.4826 258.112Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_210_182)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 314,
    r: 16,
    fill: "#A85CD7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 309.162H35.8001V307.296C35.8001 306.929 35.5001 306.629 35.1335 306.629H28.6001C28.2334 306.629 27.9334 306.929 27.9334 307.296V309.162H25C24.4334 309.162 24 309.629 24 310.162V312.729H40V310.162C40 309.629 39.5666 309.162 39 309.162H39.0001ZM29.2667 307.962H34.4667V309.162H29.2667V307.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 315.059H36.1V313.859H27.9V315.059H26.2V313.859H24V320.359C24 320.893 24.4334 321.359 25 321.359H39C39.5667 321.359 40 320.893 40 320.359V313.859H37.8V315.059Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_210_182",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_210_182",
    x: 0,
    y: 59,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_210_182",
    x: 0,
    y: 174,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_210_182",
    x: 0,
    y: 118,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_210_182",
    x: 0,
    y: 230,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_210_182",
    x: 0,
    y: 286,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 18)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_210_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 77)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step_3.553b765a170471e2eefb5620ea8b04e5.svg";
export { ForwardRef as ReactComponent };